import cx from 'classnames';
import type { FunctionComponent } from 'react';
import { useCallback, useState } from 'react';

import Badge from '@atlaskit/badge';
import { useWorkspaceUserLimit } from '@trello/workspaces/user-limit';

import { CollaboratorsBadgeTooltip } from './CollaboratorsBadgeTooltip';

import styles from './CollaboratorsBadge.less';

export const CollaboratorsBadge: FunctionComponent<{
  collaboratorCount: number;
  workspaceId: string;
}> = ({ collaboratorCount, workspaceId }) => {
  const { isUserWorkspaceMember } = useWorkspaceUserLimit({
    workspaceId,
  });
  const [isCtaClicked, setIsCtaClicked] = useState(false);

  const enableTooltip = useCallback(() => {
    setIsCtaClicked(false);
  }, []);

  const onCtaClick = useCallback(() => {
    setIsCtaClicked(true);
  }, []);

  if (!isUserWorkspaceMember) {
    return null;
  }

  if (isCtaClicked) {
    return (
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      <span
        onMouseEnter={enableTooltip}
        role="status"
        className={cx({
          [styles.collaboratorsBadge]: true,
          [styles.atLimit]: collaboratorCount === 10,
          [styles.overLimit]: collaboratorCount > 10,
        })}
      >
        <Badge>{`${collaboratorCount} / 10`}</Badge>
      </span>
    );
  }

  return (
    <CollaboratorsBadgeTooltip
      workspaceId={workspaceId}
      onCtaClick={onCtaClick}
    >
      <span
        role="status"
        className={cx({
          [styles.collaboratorsBadge]: true,
          [styles.atLimit]: collaboratorCount === 10,
          [styles.overLimit]: collaboratorCount > 10,
        })}
      >
        <Badge>{`${collaboratorCount} / 10`}</Badge>
      </span>
    </CollaboratorsBadgeTooltip>
  );
};
